<template>
    <div class="message_form_container">
        <form @submit.prevent="sendMessage">
            <div class="input_group align_center">
                <label for="title" class="white_text" style="margin-top: 15px;">제목:</label>
                <input type="text" id="subject" class="input_box" v-model="state.subject" maxlength="50" @input="updateRemainingChars"
                    required />
                <small class="length_count">{{ remainingChars.subject }}/50</small>
            </div>
            <div class="input_group">
                <label for="content" class="white_text">내용:</label>
                <textarea id="content" class="input_box increased_height" v-model="state.content" maxlength="200" @input="updateRemainingChars"
                    required></textarea>
                <small class="length_count">{{ remainingChars.content }}/200</small>
            </div>
            <div class="button_group">
                <button type="button" class="close_button" @click="closeForm">닫기</button>
                <button type="submit" class="send_button">등록하기</button>
            </div>
        </form>
    </div>
</template>

<script>
import { reactive } from '@vue/reactivity'
import API from '@/components/js/API';
import Swal from 'sweetalert2';

export default {
    props: ['reply_msg'], // 자식 컴포넌트로 전달할 prop 정의
    data() {
        return {
            state: reactive({
                subject: '',
                content: '',
            }),
            remainingChars: {
                subject: 50,
                content: 200
            },
            replyMessage : this.reply_msg
        };
    },
    methods: {
        updateRemainingChars() {
            this.remainingChars.subject = 50 - this.state.subject.length;
            this.remainingChars.content = 200 - this.state.content.length;
        },
        isNullOrEmpty(str) {
            return !str || !str.trim();
        },
        sendMessage() {
            if (this.replyMessage.groupno != '')
            {
                const form = {
                    subject : this.state.subject,
                    content : this.state.content
                }
                API.AxiosPost('qna/registQna', form, true,
                    (res) => {
                        console.log(res);
                        if (res.status == 200) {
                            switch (res.data.code) {
                                case '200':

                                    break;
                                default:

                                    break;
                            }
                            this.$emit('message-sent');
                            this.title = '';
                            this.content = '';
                            this.closeForm();
                            API.showToast('success', '문의 등록 완료')
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                html: '처리과정에 문제가 발생했습니다.<br>해당 현상 반복시 문의바랍니다.',
                            });
                            console.log("return code : " + res.data.code);
                        }
                    }
                )
            }
            else
            {
                const form = {
                    subject : this.state.subject,
                    content : this.state.content,
                    groupno : this.replyMessage
                }
                API.AxiosPost('qna/replyQna', form, true,
                    (res) => {
                        console.log(res);
                        if (res.status == 200) {
                            switch (res.data.code) {
                                case '200':
                                    // 성공적으로 응답 받았을 때의 처리
                                    API.showToast('success', '문의 등록 완료')
                                    break;
                                default:
                                    // 다른 응답 코드 처리
                                    Swal.fire({
                                        icon: 'error',
                                        html: '처리과정에 문제가 발생했습니다.<br>해당 현상 반복시 문의바랍니다.',
                                    });
                                    break;
                            }
                            this.$emit('message-sent');
                            this.title = '';
                            this.content = '';
                            this.replyGroupno = null;
                            this.closeForm();
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                html: '처리과정에 문제가 발생했습니다.<br>해당 현상 반복시 문의바랍니다.',
                            });
                            console.log("return code : " + res.data.code);
                        }
                    }
                )
            }
        },
        
        closeForm() {
            this.replyMessage = '';
            this.$emit('close-form');
        },
        adjustTextareaHeight() {
            const textarea = document.getElementById('content');
            textarea.style.height = "auto";
            textarea.style.height = (textarea.scrollHeight) + "px";
        }
    },
    mounted() {
        this.adjustTextareaHeight(); // 컴포넌트가 마운트될 때 textarea의 높이를 조절합니다.
    }
};
</script>

<style scoped>
.message_form_container {
    max-width: 500px;
    margin: auto;
}

h2 {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
}

.white_text {
    color: white;
}

.input_group {
    display: flex;
    align-items: center;
    /* 상하 중앙 정렬 */
    margin-bottom: 20px;
}

.input_group label {
    flex: 0 0 100px;
}

.input_box {
    margin-right: 20px;
    flex: 1;
    padding: 10px;
    /* color: black; */ /* 여기에서는 색상을 지정하지 않습니다. */
}

.increased_height {
    min-height: 150px;
    color: black;
    /* 최소 높이를 150px로 설정합니다. */
}

.button_group {
    display: flex;
    justify-content: space-between;
}

.send_button,
.close_button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.send_button {
    background-color: #4CAF50;
    color: white;
}

.close_button {
    background-color: #f44336;
    color: white;
}
.length_count {
    color: white;
    width: 50px;
}
</style>